var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"shop-go"},[_c('h2',[_vm._v("GO，去看看他们的超级员工！")]),_c('v-nav-button',{attrs:{"path":"/home","width":"70","height":"30"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }